export const contacts = {
  tel: "+998 77 191 06 06",
  tel2: "+998 77 122 06 06",
  email: "info@manino.uz",
  telegramLink: "https://t.me/manino_service",
  instagramLink: "https://www.instagram.com/manino_service/",
  facebookLink: "https://www.facebook.com/manino.service/",
};
